import { Component, OnInit } from '@angular/core';
import { RegisterService } from './register-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router'
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-register-boxed',
  templateUrl: './register.component.html',
  styles: []
})
export class RegisterBoxedComponent implements OnInit {

  test: any;
  disableButton: boolean = false;
  registerData: any = {
    name: {
      first: '',
      last: ''
    },
    annonymous_name: '',
    email: "",
    password: "",
    mobile_number: "",
    age: "",
    state: "",
    gender: "",
    isVolunteer_intrested: false,
    termsChecked: false
  }
  States: any;
  currentDate = new Date();
  // current day
  currentDay = ("0" + this.currentDate.getDate()).slice(-2);
  // current month
  currentMonth = ("0" + (this.currentDate.getMonth() + 1)).slice(-2);
  // current year
  currentYear = this.currentDate.getFullYear();
  selectedDOB: string;
  stateSelected: boolean;
  genderSelected: boolean;
  showPasswordHint: boolean = false;

  constructor(private registerService: RegisterService,
    private toastr: ToastrService,
    private router: Router) {
    console.log('current-yyyy', this.currentYear);
    console.log('current-mm', this.currentMonth);
    console.log('current-dd', this.currentDay);
    console.log('currentDate', this.currentDate);
  }

  ngOnInit() {
    this.registerService.getState().subscribe(res => {
      this.States = res.data
      console.log('STATES', res)
    })
  }

  selectDOB(dob) {
    console.log('DOB -_---->>', dob);
    this.selectedDOB = dob.year + '-' + dob.month + '-' + dob.day;
  }

  selectState(state) {
    this.stateSelected = true;
    console.log('stateSelected:', state);

  }

  selectGender(gender) {
    this.genderSelected = true;
    console.log('genderSelected:', gender);

  }
  trimFirstName(ev) {
    console.log(ev);
    this.registerData.name.first = ev.target.value.trim();
  }
  trimLasName(ev) {
    console.log(ev);
    this.registerData.name.last = ev.target.value.trim();
  }
  trimAnonymousName(ev) {
    console.log(ev);
    this.registerData.annonymous_name = ev.target.value.trim();
  }
  stopSpacesInPassword(ev) {
    console.log(ev);
    this.registerData.password = ev.target.value.trim();
    this.showPasswordHint = false;
  }

  passwordHint() {
    this.showPasswordHint = true;
  }
  register(data) {
    var birthDate = new Date(this.selectedDOB);
    var age = this.currentDate.getFullYear() - birthDate.getFullYear();
    // if (age < 18) {
    //   this.toastr.error('DOB should be 18 years or above it.');
    // } else {   }
    var userEntered = new Date(this.selectedDOB); // valueAsNumber has no time or timezone!
    var now = new Date();
    var today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    if (userEntered.getTime() < today.getTime() || userEntered.getTime() == today.getTime()) {

      console.log('selectedDOB-AgeIN-Else -_---->>', age);
      this.disableButton = true;
      // data.age = moment.utc(data.age).format()
      const signupDetails = JSON.parse(JSON.stringify(data))
      signupDetails.age = this.selectedDOB
      signupDetails.email = signupDetails.email.toLowerCase()
      console.log('in register', signupDetails)
      this.registerService.onRegister(signupDetails).then((res) => {
        this.router.navigate(['/login'])
        this.toastr.success(res.message);
        this.disableButton = false;
      }, error => {
        this.router.navigate(['/register'])
        console.log('fail callback', error.status)
        if (error.status == 400) {
          this.disableButton = false;
          this.toastr.error('User already exists with this email');
        }
      }).catch(e => {
        console.log('catch', e);
      });
    }
    else {
      this.toastr.error('Invalid date.');
    }
  }

}
